import React, { useEffect, useState } from 'react';
import { DetailInfo, ImageArea } from './styles';
import InfoCard from 'components/InfoCard';
import { useParams } from 'react-router';
import PublicService from 'services/PublicService';
import ContactCard from 'components/ContactCard';
import IEvent from 'interfaces/IEvent';
import MapDetailPage from 'components/Map/DetailMap';
import { useLoading } from 'hooks/useLoading';
import { formatDate } from 'utils/string';
import MainTitle from 'components/MainTitle';
import { ImageViewer, ImageViewerItem } from 'components/ImageViewer';
import InfoCardPhotos from 'components/InfoCardPhotos';
import { parseCropHash, getFramedImageStyles } from 'utils/cropUtils';

const EventDetailCard = (): JSX.Element => {
  const { slug } = useParams<{ slug: string }>();

  const getEvent = async () => {
    const service = new PublicService();
    return service.getEvents(slug);
  };

  return <Event getEvent={getEvent} />;
};

interface IProps {
  getEvent: () => Promise<IEvent>;
}

export const Event = (props: IProps): JSX.Element => {
  const [events, setEvents] = useState<IEvent | undefined>();
  const { openLoading, closeLoading } = useLoading();

  useEffect(() => {
    getEvents();
  }, []);

  const getEvents = async () => {
    try {
      openLoading();
      const events = await props.getEvent();
      setEvents(events);
      closeLoading();
    } catch (error) {
      closeLoading();
    }
  };

  const fullAddress = [
    events?.addressInfo?.street,
    events?.addressInfo?.number,
    events?.addressInfo?.additionalData?.trim() ? events?.addressInfo?.additionalData : null,
    events?.addressInfo?.neighborhood,
    events?.addressInfo?.city,
    events?.addressInfo?.state,
    events?.addressInfo?.zipCode,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <ImageViewer>
      <MainTitle>Agenda</MainTitle>
      <DetailInfo>
        <InfoCard
          id={events?.id ?? 0}
          category={events?.category}
          date={events?.date}
          title={events?.title}
          description={events?.description}
          startDate={formatDate(events?.startDate ?? '')}
          endDate={formatDate(events?.endDate ?? '')}
          startTime={events?.startTime}
          endTime={events?.endTime}
          place={events?.place}
          price={events?.price}
        />
        {(() => {
          const { cleanUrl, crop } = parseCropHash(events?.image);
          const { containerStyle, imageStyle } = getFramedImageStyles(crop);
          return (
            <ImageViewerItem src={cleanUrl}>
              <ImageArea
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                }}>
                <div
                  style={{
                    position: 'absolute',
                    top: '-10%',
                    left: '-10%',
                    width: '120%',
                    height: '120%',
                    background: `url(${cleanUrl}) center center / cover no-repeat`,
                    filter: 'blur(15px)',
                    zIndex: 1,
                  }}
                />
                <div style={containerStyle}>
                  <img src={cleanUrl} alt={events?.title ?? ''} style={imageStyle} />
                </div>
              </ImageArea>
            </ImageViewerItem>
          );
        })()}
      </DetailInfo>
      <InfoCardPhotos images={events?.images?.map(({ image }) => image)} />
      <ContactCard
        key={0}
        email={events?.email}
        facebookLink={events?.facebookLink}
        instagramLink={events?.instagramLink}
        phone={events?.phone}
        site={events?.site}
        whatsapp={events?.whatsapp}
        youtubeLink={events?.youtubeLink}
      />

      <MapDetailPage address={fullAddress} placeId={events?.placeId} />
    </ImageViewer>
  );
};

export default EventDetailCard;
